import { FunctionComponent, ReactNode } from 'react';
import { FormattedDate } from 'react-intl';
import { NoValue } from './NoValue';

type OptionalFormattedDateProps = {
    date?: Date | undefined;
    fallbackComponent?: ReactNode | undefined;
};

export const OptionalFormattedDate: FunctionComponent<OptionalFormattedDateProps> = ({
    date,
    fallbackComponent = <NoValue />,
}) => {
    return date !== undefined ? <FormattedDate value={date} /> : fallbackComponent;
};
